// Paese attivo (multi-paese). Modulo senza React: lo usano apiFetch e formatPrice.
const STORAGE_KEY = 'sm_country';
let current = { code: null, currency: 'CHF', locale: 'de-CH' };

export const getStoredCountry = () => {
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
};
export const storeCountry = (code) => {
  try { localStorage.setItem(STORAGE_KEY, code); } catch { /* storage bloccato */ }
};

export const getCountryCode = () => current.code || getStoredCountry();
export const getCurrency = () => current.currency;
export const getPriceLocale = () => current.locale;

export function applyCountry(cfg) {
  if (cfg) current = { code: cfg.code, currency: cfg.currency, locale: cfg.locale };
}

// Sito: ogni dominio (.ch, .it) è già un paese.
export function domainCountry(countries) {
  const host = window.location.hostname.toLowerCase();
  const hit = countries.find(c => c.domains.some(d => host === d || host.endsWith(`.${d}`)));
  return hit ? hit.code : null;
}

// App / dominio neutro: paese del telefono (regione della lingua, es. it-IT → it).
export function phoneCountry(countries) {
  const langs = navigator.languages?.length ? navigator.languages : [navigator.language || ''];
  for (const l of langs) {
    const m = String(l).match(/[-_]([A-Za-z]{2})$/);
    const code = m && m[1].toLowerCase();
    if (code && countries.some(c => c.code === code)) return code;
  }
  return null;
}
